import {Utils} from '../core/utils';

import 'jquery';
import 'gsap';
import 'ScrollMagic';
import 'ScrollMagic.animation.gsap';
import 'ScrollMagic.debug.addIndicators';


export default class NwFx {
    constructor() {
        this.debug = false;
    }

    /**
     * Restituisce un controller di ScrollMagic condiviso
     *
     * @returns {ScrollMagic.Controller|*}
     */
    getSharedController() {
        if (!this._sharedController) {
            this._sharedController = new ScrollMagic.Controller({addIndicators: this.debug});
        }
        return this._sharedController;
    }

    /**
     * Estrai tutte le proprietà data-fx- dall'elemento indicato eccetto quelle indicate dal parametro skip
     *
     * @param $e Oggetto jQuery da cui estrarre le proprietà data-fx
     * @param skip Array di proprietà da cui non estrarre i valori (es. ['duration', 'offset'] per saltare gli attributi data-fx-duration e data-fx-offset)
     * @returns {{}} Un oggetto {nomeProp: val, ...}
     * @private
     */
    _getFxProps($e, skip=null) {
        const data = $e.data();
        var props = {};
        for (let k in data) {

            /**
            * Polyfill per compatibilità con IE11 che non supporta startsWith()
            * https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith#Polyfill
            */
            if (!String.prototype.startsWith) {
                String.prototype.startsWith = function(searchString, position){
                    position = position || 0;
                    return this.substr(position, searchString.length) === searchString;
                };
            }

            if (data.hasOwnProperty(k) && k.startsWith('fx')) {
                // Converto fxNomeProp a nomeProp (es. da fxDelay a delay)
                const prop = k.charAt(2).toLowerCase() + k.slice(3);
                if (!skip || !skip.indexOf(prop) >= 0) {
                    // Propietà da non saltare
                    props[prop] = data[k];
                }
            }
        }

        return props;
    }

    /**
     * Estrae una singola proprietà data-fx- dall'elemento indicato
     * o restituisce il valore default indicato dal parametro defaultValue
     *
     * @param $e Oggetto jQuery da cui estrarre la proprietà data-fx
     * @param propName Nome della proprietà
     * @param defaultValue Valore predefinito in assenza della proprietà
     * @returns {*} Un singolo valore
     * @private
     */
    _getFxProp($e, propName, defaultValue=null) {
        return $e.data('fx-' + propName) || defaultValue;
    }

    /**
     * Avvia l'animazione dei parallax presenti nella pagina e che corrispondono al selettore indicato
     * Usare gli attributi data-fx-{offset|hook|duration} per sovrascrivere il relativo valore default.
     *
     * @param selector Una stringa contenente il selettore degli elementi o un oggetto jquery o degli elementi HTML
     * @param backgroundPosition Posizione del background alla fine dello scroll
     * @param duration Valore duration della scena di ScrollMagic
     * @param hook Valore triggerHook della scena di ScrollMagic
     */
    runParallax({selector='.parallaxRow', backgroundPosition='50% 20%', duration='auto', hook='onEnter'}={}) {
        var controller = this.getSharedController();

        var winHeight = Utils.shared().window().height();

        $(selector).each((i, e) => {
            const $e = $(e);

            let _duration = this._getFxProp($e, 'duration', duration);
            let _bgPos = this._getFxProp($e, 'background-position', backgroundPosition);
            let _hook = this._getFxProp($e, 'hook', hook);

            if (_duration === 'auto') {
                const h = $e.outerHeight();
                _duration = (winHeight + h) + 'px';
            }

            new ScrollMagic.Scene({
                triggerElement: e,
                triggerHook: _hook,
                duration: _duration
            })
                .setTween(e, {backgroundPosition: _bgPos}).addTo(controller);

        });
    }

    /**
     * Avvia l'animazione dei parallax presenti nella pagina e che corrispondono al selettore indicato
     * Usare gli attributi data-fx-{offset|hook|duration} per sovrascrivere il relativo valore default.
     *
     * @param selector Una stringa contenente il selettore degli elementi o un oggetto jquery o degli elementi HTML
     * @param backgroundPosition Posizione del background alla fine dello scroll
     * @param duration Valore duration della scena di ScrollMagic
     * @param hook Valore triggerHook della scena di ScrollMagic
     */
    runParallaxElement({selector='.parallaxElement', topPosition='25%', duration='auto', hook='onEnter'}={}) {
        var controller = this.getSharedController();

        var winHeight = Utils.shared().window().height();

        $(selector).each((i, e) => {
            const $e = $(e);

            let _duration = this._getFxProp($e, 'duration', duration);
            //let _bgPos = this._getFxProp($e, 'background-position', backgroundPosition);
            let _topPos = this._getFxProp($e, 'top', topPosition);
            let _hook = this._getFxProp($e, 'hook', hook);

            if (_duration === 'auto') {
                const h = $e.height();
                _duration = (winHeight + h) + 'px';
            }

            new ScrollMagic.Scene({
                triggerElement: e,
                triggerHook: _hook,
                duration: _duration
            })
                .setTween(e, {paddingTop: _topPos}).addTo(controller);

        });
    }

    /**
     * Avvia l'animazione degli slide in presenti nella pagina e che corrispondono al selettore indicato.
     *
     * Usare l'attributo data-fx-direction per specificare la direzione dell'ingresso ('left', 'right', 'top', 'bottom'),
     * (es. con 'left' l'elemento si muoverà da destra verso sinistra)
     *
     * Usare gli attributi data-fx-{offset|hook|duration} per sovrascrivere il relativo valore default.
     *
     * Usare gli attributi data-fx-{nomeVar} per specificare valori personalizzati per il singolo elemento,
     * sono ammessi tutti i nomi di variabile indicati nella documentazione di TweenMax
     *
     * @param selector Una stringa contenente il selettore degli elementi o un oggetto jquery o degli elementi HTML
     * @param duration Durata in secondi dell'animazione
     * @param speed Velocità dell'animazione (se indicato, il parametro duration verrà calcolato autonomamente)
     * @param offset Valore offset della scena di ScrollMagic
     * @param hook Valore triggerHook della scena di ScrollMagic
     * @param tweenVars Oggetto variabili tween default per tutti gli slide in
     */
    runSlideIn({selector=".fxSlideIn", duration=1.5, speed=null, offset=0, hook='onEnter', tweenVars=null}={}) {
        const controller = this.getSharedController();
        const tweenDefaults = {
            opacity: 0,
            ease: Power2.easeOut
        };
        var margedVars = $.extend(true, {}, tweenDefaults, tweenVars);

        $(selector).each((i, e) => {
            const $e = $(e);
            const $parent = $e.parent();
            const direction = this._getFxProp($e, 'direction', 'left');
            const orientation = (direction === 'left' || direction === 'right') ? 'h' : 'v';
            const distance = (orientation === 'h') ? $parent.width() : $parent.height();
            const elementTweenVars =this._getFxProps($e, ['direction', 'offset', 'hook', 'duration']);

            let _vars = $.extend(true, {}, margedVars, elementTweenVars);
            let _duration = this._getFxProp($e, 'duration', duration);
            let _hook = this._getFxProp($e, 'hook', hook);
            let _offset = this._getFxProp($e, 'offset', offset);

            if (speed) {
                _duration = Math.abs(distance * speed) * 0.01;
            }

            switch (direction) {
                case 'left':
                    _vars['x'] = distance;
                    break;
                case 'right':
                    _vars['x'] = -distance;
                    break;
                case 'top':
                    _vars['y'] = distance;
                    break;
                case 'bottom':
                    _vars['y'] = -distance;
                    break;
            }

            var triggerElement = e;
            if (orientation === 'v') {
                triggerElement = $parent[0];
            }

            var scene = new ScrollMagic.Scene({
                triggerElement: triggerElement,
                triggerHook: _hook,
                offset: _offset});

            scene.setTween(TweenMax.from(e, _duration, _vars)).addTo(controller);
        });
    }

    /**
     * Avvia l'animazione dei fade in presenti nella pagina e che corrispondono al selettore indicato.
     *
     * Usare gli attributi data-fx-{offset|hook|duration} per sovrascrivere il relativo valore default.
     *
     * Usare gli attributi data-fx-{nomeVar} per specificare valori personalizzati per il singolo elemento,
     * sono ammessi tutti i nomi di variabile indicati nella documentazione di TweenMax
     *
     * @param selector Una stringa contenente il selettore degli elementi o un oggetto jquery o degli elementi HTML
     * @param duration Durata in secondi dell'animazione
     * @param offset Valore offset della scena di ScrollMagic
     * @param hook Valore triggerHook della scena di ScrollMagic
     * @param tweenVars Oggetto variabili tween default per tutti i fade in
     */
    runFadeIn({selector=".fxFadeIn", duration=1.5, offset=0, hook='onEnter', tweenVars=null}={}) {
        const controller = this.getSharedController();
        const tweenDefaults = {
            opacity: 0,
            ease: Power2.easeOut
        };
        var margedVars = $.extend(true, {}, tweenDefaults, tweenVars);


        $(selector).each((i, e) => {
            const $e = $(e);
            const elementTweenVars =this._getFxProps($e, ['offset', 'hook', 'duration']);

            let _vars = $.extend(true, {}, margedVars, elementTweenVars);
            let _duration = this._getFxProp($e, 'duration', duration);
            let _hook = this._getFxProp($e, 'hook', hook);
            let _offset = this._getFxProp($e, 'offset', offset);

            var scene = new ScrollMagic.Scene({
                triggerElement: e,
                triggerHook: _hook,
                offset: _offset});

            scene.setTween(TweenMax.from(e, _duration, _vars)).addTo(controller);
        });
    }

    /**
     * Avvia l'animazione dei counter in presenti nella pagina e che corrispondono al selettore indicato.
     *
     * Usare gli attributi data-fx-{offset|hook|duration} per sovrascrivere il relativo valore default.
     *
     * Usare gli attributi data-fx-{nomeVar} per specificare valori personalizzati per il singolo elemento,
     * sono ammessi tutti i nomi di variabile indicati nella documentazione di TweenMax
     *
     * @param selector Una stringa contenente il selettore degli elementi o un oggetto jquery o degli elementi HTML
     * @param duration Durata in secondi dell'animazione
     * @param offset Valore offset della scena di ScrollMagic
     * @param hook Valore triggerHook della scena di ScrollMagic
     */
    runCounter({selector=".counter", duration=2000, offset=0, hook='onEnter'}={})  {
        const controller = this.getSharedController();

        $(selector).each((i, e) => {
            const $e = $(e);
            const value = $e.find(".counter__value").attr("data-stop");

            let _duration = this._getFxProp($e, 'duration', duration);
            let _offset = this._getFxProp($e, 'offset', offset);
            let _hook = this._getFxProp($e, 'hook', hook);

            var scene = new ScrollMagic.Scene({
                triggerElement: e,
                triggerHook: _hook,
                offset: _offset});

            scene.on('start', function(){

                $({
                    countNum: $e.find(".counter__value").text()
                }).animate({
                    countNum: value
                }, {
                    duration: _duration,
                    easing: "linear",
                    step: function() {
                        $e.find(".counter__value").text(Math.floor(this.countNum));
                    },
                    complete: function() {
                        $e.find(".counter__value").text(this.countNum);
                    }
                });

            });

            scene.addTo(controller);
        });
    }

}



/** WEBPACK FOOTER **
 ** ./assets/scripts/src/core/fx.js
 **/